<template>
  <Loader v-if="loading" />
  <div class="credit-invoice">
    <div class="header-section">
      <h2 class="page-title">Report Mensile dei caricamenti firmati</h2>
      <p class="subtitle">Gestione e monitoraggio dei caricamenti mensili</p>
    </div>
    
    <div v-if="is_admin" class="filter-section">
      <div class="section-header">
        <h3>Filtri</h3>
      </div>
      <div class="filter-content">
        <div class="agent-selector">
          <span class="label">Seleziona l'agente:</span>
          <Dropdown v-model="selectedAgent" :options="agents" filter optionLabel="name" 
                    optionValue="name" placeholder="Seleziona l'agente" 
                    class="dropdown-custom" @update:modelValue="onChangeAgent($event)">
          </Dropdown>
        </div>
      </div>
    </div>
    
    <div class="date-filter-section" v-if="loaded">
      <div class="section-header">
        <h3>Periodo di riferimento</h3>
      </div>
      <div class="date-filter-content">
        <div class="date-selector">
          <span class="label">Filtra per Mese:</span>
          <Calendar v-model="date" :maxDate="maxDate" :manualInput="false" 
                   view="month" dateFormat="mm/yy" class="calendar-custom"
                   @update:modelValue="onChangeDate($event)"/>
        </div>
      </div>
    </div>
    
    <div class="report-section mb-3" v-if="loaded">
      <div class="section-header">
        <h3>Report Agente</h3>
      </div>
      <div class="report-content">
        <DataTable :value="report" stripedRows tableStyle="min-width: 50rem" class="table-custom">
          <Column field="nome" header="Agente"></Column>
          <Column field="pods" header="N. PODS"></Column>
          <Column field="pdrs" header="N. PDRS"></Column>
          <Column field="count_total_pp" header="Totale PP">
            <template #body="{data}">
              {{ data.count_total_pp }}
            </template>
          </Column>
          <Column field="rid" header="Percentuale Rid">
            <template #body="{data}">
              {{ data.rid }} / {{data.count_total_pp}}
            </template>
          </Column>
          <Column header="Percentuale OTP su caricamenti">
            <template #body="{data}">
              {{ data.otp }} / {{data.n_caricamenti}}
            </template>
          </Column>
        </DataTable>
        
        <div class="total-summary">
          <DataTable :value="total_month" tableStyle="min-width: 50rem" class="table-summary-custom">
            <Column field="nome" header="">
              <template #body>
                {{name_agente}}
              </template>
            </Column>
            <Column field="pods" header="Totale forniture Energia"></Column>
            <Column field="pdrs" header="Totale forniture Gas"></Column>
            <Column field="total_pp" header="Totale forniture">
              <template #body="{data}">
                {{ data.total_pp }}
              </template>
            </Column>
            <Column field="rid" header="Percentuale di Rid su Totale Forniture">
              <template #body="{data}">
                {{ data.rid }} / {{data.total_pp}}
              </template>
            </Column>
            <Column header="Percentuale OTP su caricamenti">
              <template #body="{data}">
                {{ data.otp }} / {{data.n_caricamenti}}
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
    </div>
    
    <div class="uploads-section mb-3" v-if="loaded">
      <div class="section-header">
        <h3>Report Caricamenti</h3>
      </div>
      <div class="uploads-content">
        <Accordion :multiple="true" :activeIndex="activeIndex" class="accordion-custom">
          <AccordionTab v-for="settimana in items" :key="settimana.title" :header="settimana.title">
            <div v-if="settimana.content">
              <DataTable :value="settimana.content" stripedRows tableStyle="min-width: 50rem" class="table-custom">
                <Column field="intestazione" header="Nome Cliente">
                  <template #body="{data}">
                    <strong>{{ data.intestazione }}</strong>
                  </template>
                </Column>
                <Column field="pods" header="N. PODS"></Column>
                <Column field="pdrs" header="N. PDRS"></Column>
                <Column field="count_total_pp" header="Totale PP"></Column>
                <Column field="rid" header="Percentuale Rid">
                  <template #body="{data}">
                    {{ ((data.rid/data.count_total_pp)*100).toFixed(2) }} %
                  </template>
                </Column>
                <Column field="agenzia" header="Agenzia"></Column>
                <Column field="cartaceo" header="Tipologia contratto">
                  <template #body="{data}">
                    <strong>
                      {{ data.cartaceo ? 'CARTACEO' : 'OTP' }}
                    </strong>
                  </template>
                </Column>
              </DataTable>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </div>
  </div>
</template>

<script>
import {ref, onMounted, getCurrentInstance } from 'vue';
import Loader from "@/components/Loader.vue"
import Service from '@/services/ask-pratiche/pratiche-wizard'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useToast } from "primevue/usetoast";
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Calendar from 'primevue/calendar';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import roles from '@/config/roles'

export default {
  components: {
    Loader,
    Calendar
  },
  
  setup (props, {emit}) { 
    const self = getCurrentInstance();
    const store = useStore()
    const toast = useToast();

    self.$eventBus = self.appContext.config.globalProperties.$eventBus
    const currentUser = ref(store.state.auth.user)

    const loading = ref(false)
    const loaded = ref(false)
    const date = ref(new Date())
    const items = ref([])
    const report = ref([])
    const service = new Service(self.$eventBus)
    const activeIndex = ref([])
    const total_month = ref([
      {
        pods:0,
        pdrs:0,
        rid:0,
        total_month:0,
        caricati:0,
        n_caricamenti:0,
        otp:0,
      }
    ])
    const selectedAgent = ref()
    const agents = ref()
    const is_admin = ref()
    const name_agente = ref()

    const maxDate = ref(new Date());
    onMounted(() => { 
      setView()
    })

    const onChangeDate = (evt) => {
      getData()
    }

    const setView = async () => {
      selectedAgent.value = currentUser.value.role == roles.agent.role ? currentUser.value.id : null
      is_admin.value = currentUser.value.role == roles.agent.role ? false : true
      await getAgents()
      if(!is_admin.value){
        name_agente.value = agents.value.find(agent => agent.id == selectedAgent.value).name
        getData()
      }
    } 
    
    const onChangeAgent = (evt) => {
      selectedAgent.value = agents.value.find(agent => agent.name == evt).id
      getData()
      name_agente.value = agents.value.find(agent => agent.id == selectedAgent.value).name
    } 
    
    const getAgents = async () => {
      loading.value = true
      await service.getAgents()
      .then((res)=>{
        agents.value = res.items
      }).finally(()=>{
        loading.value = false
      })
    }
    
    const getData = async () => {
      loaded.value = false
      loading.value = true
      let fd = new FormData();
      
      let mese = date.value.getMonth()+1
      mese = mese.toString().padStart(2,'0')
      let anno = date.value.getFullYear() 
      let filtro = `${anno}-${mese}`
      fd.append('filtro', filtro);
      fd.append('agente_id', selectedAgent.value)

      await service.getReportCaricamentiAgente(fd)
      .then((res)=>{
        items.value = res.items
        items.value.forEach((item, index)=>{
          if (item.content.length) {
            activeIndex.value.push(index)
          }
        })
        report.value = res.report

        let pods = 0
        let pdrs = 0
        let rid = 0
        let caricati = 0
        let n_caricamenti = 0
        let otp = 0

        report.value.forEach((agenzia)=>{
          pods += agenzia.pods
          pdrs += agenzia.pdrs
          rid += agenzia.rid
          caricati += agenzia.caricati
          n_caricamenti += agenzia.n_caricamenti
          otp += agenzia.otp
        })
        let total_pp = pods + pdrs
        total_month.value[0]['total_pp'] = total_pp
        total_month.value[0]['pods'] = pods
        total_month.value[0]['pdrs'] = pdrs
        total_month.value[0]['rid'] = rid
        total_month.value[0]['caricati'] = caricati
        total_month.value[0]['n_caricamenti'] = n_caricamenti
        total_month.value[0]['otp'] = otp

      }).finally(()=>{
        loaded.value = true
        loading.value = false
      })
    }

    return {
      loading,
      items,
      report,
      date,
      maxDate,
      onChangeDate,
      activeIndex,
      total_month,
      roles,
      currentUser,
      agents,
      is_admin,
      onChangeAgent,
      loaded,
      name_agente,
    }
  },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');

.credit-invoice {
  font-family: 'Montserrat', sans-serif;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 1.5rem;
}

.header-section {
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 1rem;
}

.page-title {
  font-size: 1.8rem;
  font-weight: 600;
  color: #2c3e50;
  margin: 0;
}

.subtitle {
  color: #7f8c8d;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.filter-section,
.date-filter-section,
.report-section,
.uploads-section {
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 1.5rem;
  overflow: hidden;
}

.section-header {
  background-color: #f8f9fa;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #eaeaea;
}

.section-header h3 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #3498db;
  margin: 0;
}

.filter-content,
.date-filter-content,
.report-content,
.uploads-content {
  padding: 1.5rem;
}

.agent-selector,
.date-selector {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.label {
  font-weight: 600;
  color: #7f8c8d;
  min-width: 150px;
}

.dropdown-custom,
.calendar-custom {
  flex: 1;
  max-width: 300px;
}

:deep(.p-dropdown) {
  border-radius: 6px;
  border: 1px solid #e0e0e0;
  transition: all 0.2s ease;
}

:deep(.p-dropdown:hover) {
  border-color: #3498db;
}

:deep(.p-calendar) {
  border-radius: 6px;
  overflow: hidden;
}

:deep(.p-calendar .p-inputtext) {
  border-color: #e0e0e0;
  border-radius: 6px;
  height: 42px;
  padding-left: 1rem;
  font-weight: 500;
}

:deep(.p-calendar .p-inputtext:focus) {
  border-color: #3498db;
  box-shadow: 0 0 0 2px rgba(52, 152, 219, 0.2);
}

.total-summary {
  margin-top: 1.5rem;
  border-top: 1px solid #eaeaea;
  padding-top: 1.5rem;
}

:deep(.p-datatable) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  margin-bottom: 1.5rem;
}

:deep(.p-datatable-header),
:deep(.p-datatable-footer) {
  background-color: #f5f7fa;
  padding: 1rem;
  font-weight: 600;
}

:deep(.p-datatable-thead > tr > th) {
  background-color: #f8f9fa;
  color: #555;
  font-weight: 600;
  padding: 0.8rem 1rem;
  border-bottom: 2px solid #f0f0f0;
}

:deep(.p-datatable-tbody > tr > td) {
  padding: 0.8rem 1rem;
  border-bottom: 1px solid #f5f5f5;
}

:deep(.p-datatable-tbody > tr:nth-child(even)) {
  background-color: #fafafa;
}

:deep(.p-datatable-tbody > tr:hover) {
  background-color: #f5f7fa;
}

:deep(.p-datatable-tbody > tr > td strong) {
  font-weight: 600;
  color: #2c3e50;
}

.table-summary-custom :deep(.p-datatable-tbody > tr > td) {
  font-weight: 600;
  background-color: #f8f9fa;
}

:deep(.p-accordion) {
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

:deep(.p-accordion-header) {
  background-color: #f8f9fa;
}

:deep(.p-accordion-header-link) {
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: #34495e;
  border-radius: 0;
  border: none;
  border-bottom: 1px solid #e6e6e6;
  transition: background-color 0.2s;
}

:deep(.p-accordion-header-link:hover) {
  background-color: #eef2f7;
}

:deep(.p-accordion-tab-active .p-accordion-header-link) {
  border-left: 4px solid #3498db;
}

:deep(.p-accordion-content) {
  padding: 1.5rem;
  background-color: white;
}

@media (max-width: 768px) {
  .agent-selector,
  .date-selector {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.5rem;
  }
  
  .dropdown-custom,
  .calendar-custom {
    max-width: 100%;
    width: 100%;
  }
  
  :deep(.p-datatable) {
    overflow-x: auto;
  }
}
</style>